import { ArrowRight, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import heroImage from '@/assets/hero-business-consulting.webp';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Professional business consulting services"
          className="w-full h-full object-cover"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-primary-dark/95 via-primary/80 to-primary-light/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Grow Your Business.{' '}
            <span className="bg-gradient-to-r from-accent-light to-accent bg-clip-text text-transparent">
              Keep Your People.
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            We help businesses leverage technology to improve profitability 
            and retain top talent by building stronger company culture.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button variant="hero" size="xl" asChild>
              <Link to="/contact">
                Get Free Consultation <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button variant="outline" size="xl" className="bg-white/10 border-white/30 text-white hover:bg-white/20" asChild>
              <Link to="/services">
                Our Services
              </Link>
            </Button>
          </div>

          {/* External Links Section */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="text-white/80 text-sm font-medium mb-2 sm:mb-0">
              Featured Solutions:
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Button 
                variant="ghost" 
                size="sm" 
                className="bg-white/10 border border-white/20 text-white hover:bg-white/20 hover:text-white"
                onClick={() => window.open('https://ai4hr.xyz', '_blank')}
              >
                AI Concepts for the Workplace <ExternalLink className="ml-1 h-4 w-4" />
              </Button>
              
              <Button 
                variant="ghost" 
                size="sm"
                className="bg-white/10 border border-white/20 text-white hover:bg-white/20 hover:text-white"
                onClick={() => window.open('https://blacklight.fun', '_blank')}
              >
                Gamified Team Building <ExternalLink className="ml-1 h-4 w-4" />
              </Button>
              
              
              <Button 
                variant="ghost" 
                size="sm"
                className="bg-white/10 border border-white/20 text-white hover:bg-white/20 hover:text-white"
                onClick={() => window.open('https://ciyfr.io', '_blank')}
              >
                AI Workforce Intelligence <ExternalLink className="ml-1 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
